module.exports = __webpack_public_path__ + "static/coder-d0587cfdf96dba313fe1625d440033c8.mp4";